/**
 * Apple Watch preview (docs/GAME_DESIGN.md § 6): a 45 mm watch face — 198×242
 * CSS px, rounded, with a Digital Crown and side button — centred on the
 * screen. The compact start screen, the compact game and a compact game-over
 * run inside it. On a viewport the size of a real watch the case disappears
 * and the face fills the screen.
 */
import type { ReactNode } from 'react';
import { useT } from '../../i18n/index.ts';
import { Button } from '../../components/Button.tsx';
import './watch.css';

export interface WatchFrameProps {
  onExit(): void;
  /** False during a run (leaving the preview would end it). */
  canExit: boolean;
  children: ReactNode;
}

export function WatchFrame({ onExit, canExit, children }: WatchFrameProps) {
  const t = useT();
  return (
    <div className="watch">
      <p className="watch__caption">{t('shell.watchCaption')}</p>
      <div className="watch__device">
        <span className="watch__band watch__band--top" aria-hidden="true" />
        <div className="watch__case">
          <span className="watch__crown" aria-hidden="true" />
          <span className="watch__side-button" aria-hidden="true" />
          <div className="watch__face">{children}</div>
        </div>
        <span className="watch__band watch__band--bottom" aria-hidden="true" />
      </div>
      <Button variant="ghost" icon="close" className="watch__exit" disabled={!canExit} onClick={onExit}>
        {t('shell.watchExit')}
      </Button>
    </div>
  );
}
